export default {
  video: {
    desc: 'Votre portefeuille matériel crypto sécurisé',
    preOrderNow: 'Acheter',
    watchNow: 'Regarder maintenant',
  },

  introduce: {
    title:
      'KeyPal — Alliant sécurité et facilité d’utilisation, avec des avantages pleinement mis en valeur',
    desc_1: 'Cliquez sur n’importe quelle carte pour en savoir plus',
    desc_2: 'Connexion',
    desc_3: 'Sécurité',
    desc_4: 'Sauvegarde',
    desc_5: 'Passphrase',
    desc_6: 'Autonomie',
    desc_7: 'Capacité de la batterie',
    desc_8: 'Double puce',
    desc_9: 'Clavier 15 touches',
    desc_10:
      'Connexion — Plusieurs méthodes de connexion, il y en a forcément une faite pour vous',
    desc_11: 'NFC + KeyPal Card',
    desc_12: 'Utilisation',
    label_1:
      'Prend en charge la connexion du portefeuille et la signature de transactions via Bluetooth et le scan de code QR',
    label_1_1:
      'Choisissez la méthode de connexion la plus adaptée à chaque scénario pour rendre l’utilisation du portefeuille matériel plus sûre et plus pratique',
    label_2: 'KeyPal 2 prend en charge le Passphrase',
    label_2_1:
      'Avec la même phrase de récupération, vous pouvez accéder à différents portefeuilles en utilisant des Passphrases différents, ajoutant ainsi une couche supplémentaire de sécurité à votre portefeuille',
    label_3:
      'Prend en charge le NFC pour des sauvegardes plus simples et rapides',
    label_3_1:
      'KeyPal 2 vous permet de sauvegarder rapidement votre phrase de récupération sur la KeyPal Card via NFC',
    label_4: 'Capacité de batterie plus grande, passant de 300 mAh à 500 mAh',
    label_4_1:
      'Une seule charge offre jusqu’à 12 heures d’autonomie, vous libérant du stress de la batterie faible',
    label_5:
      'Le KeyPal 2 adopte une conception à double puce de qualité militaire',
    label_5_1: 'Avec une architecture MCU + SE, la sécurité commence au cœur',
    label_6:
      'Grille de 15 touches pour une saisie et une interaction simplifiées',
    label_6_1:
      'Saisissez du contenu et sélectionnez des fonctions rapidement, sans étapes longues et compliquées',
  },

  support: {
    title: 'Des millions de cryptomonnaies prises en charge',
    desc_1: 'Voir la liste des éléments pris en charge',
  },

  other: {
    title: 'Autres produits KeyPal',
    desc_1: `KeyPal Plus adopte une architecture à double puce, alliant facilité d’utilisation et sécurité. Son design minimaliste, associé à un boîtier robuste en alliage d’aluminium, offre une expérience de gestion d’actifs numériques durable et efficace`,
    desc_2: `KeyPal Card prend en charge la communication NFC, vous permettant d’enregistrer facilement vos phrases mnémoniques et clés privées d’un simple geste. Elle combine parfaitement les fonctions de sauvegarde et de signature hors ligne. Son format carte bancaire, portable et sécurisé, protège vos actifs cryptographiques à tout moment et en tout lieu`,
    desc_3: `Secret Box est fabriqué en acier inoxydable 304, offrant une résistance exceptionnelle aux hautes températures et à la corrosion. Son design à blocs de lettres et rainures facilite et pérennise le stockage de la phrase mnémonique. Avec sa conception double face A+B, il prend en charge le stockage de phrases de récupération de 12×2, 18 ou 24 mots, assurant une protection à long terme de vos actifs cryptographiques`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: 'Cliquez pour voir toutes les réponses aux FAQ',
    question_1: 'Qu’est-ce qu’un portefeuille crypto ?',
    question_2: 'Pourquoi ai-je besoin d’un portefeuille matériel ?',
    question_3:
      'Quelle est la différence entre un portefeuille matériel et une application mobile ?',
    question_4:
      'Que se passe-t-il si je perds mon appareil ? Mes cryptos sont-elles en sécurité ?',
    question_5:
      'Quels types de cryptomonnaies le portefeuille matériel KeyPal prend-il en charge ?',
  },

  discover: {
    title: 'Choisissez vos couleurs préférées de KeyPal',
    desc_1: 'Découvrir',
  },

  instructions: {
    title: 'Centre de tutoriels',
    desc: 'Démonstrations complètes pour apprendre facilement KeyPal 2, rendant la gestion des actifs cryptographiques simple et sécurisée.',
    tabs: {
      hardware: "Fonctionnalités de l'appareil",
      activation: "Tutoriel de l'appareil",
      connect: 'Connexion du portefeuille',
      upgrade: 'Mise à jour du firmware',
    },
    hardware: {
      basic: 'Opérations de base',
      power: 'Mise sous/hors tension',
      language: 'Sélection de langue',
      button: 'Opération des boutons',
      features: 'Présentation des fonctions',
      security: 'Paramètres de sécurité',
      passphrase: 'Configuration Passphrase',
      securityOverview: 'Aperçu des paramètres de sécurité',
      verifyDevice: 'Vérifier l’appareil',
      asset: "Gestion d'actifs",
    },
    activation: {
      create: 'Création de phrase mnémonique',
      createByDevice: "Génération dans l'appareil",
      import: 'Import phrase mnémonique',
      manualImport: 'Import manuel',
      keypalCardImport: 'Import via carte KeyPal',
      backup: 'Sauvegarde de la phrase',
      steelBackup: 'Copie/backup acier',
      keypalCardBackup: 'Backup via carte KeyPal',
    },
    connect: {
      bluetooth: 'Connexion Bluetooth à TokenPocket',
      connectAndAdd: "Connexion + ajout d'adresse",
      qrConnect: 'Connexion par QR',
      qrConnectTP: 'Connexion QR TokenPocket',
      qrConnectMM: 'Connexion QR MetaMask',
      transferReceive: 'Transfert & réception',
      bluetoothTransfer: 'Virement par Bluetooth',
      qrTransfer: 'Virement par QR code',
      receiveHardware: 'Recevoir via l’appareil',
      receiveApp: 'Recevoir via l’app',
      transfer: 'Transfert',
    },
    upgrade: {
      web: 'Mise à jour via page Web',
      bluetooth: 'Mise à jour par Bluetooth',
      mobile: 'Mise à jour via mobile',
      troubleshoot: 'Dépannage firmware',
      webTroubleshoot: 'Dépannage mise à jour Web',
      bluetoothTroubleshoot: 'Dépannage mise à jour Bluetooth',
    },
    relatedVideos: 'Vidéos connexes',
    playing: 'En cours de lecture',
  },
};
